import { useCallback } from "react";
import { DateTimePicker } from "../../components/DateTimePicker";
import { DelayPicker } from "../../components/DelayPicker";
import { LimitedTimeOfferExpirationTypeEnum } from "../../enums";
import {
  Description,
  ErrorMessage,
  Field,
  Fieldset,
  Label,
  Legend,
} from "../tailwind/fieldset";
import { Input, InputGroup } from "../tailwind/input";
import { Radio, RadioField, RadioGroup } from "../tailwind/radio";

export const LimitedTimeOffer = ({
  data,
  error,
  errorsMap,
  handleLimitedTimeOfferChange,
  isEditing,
  isInPanel,
  setModifications,
  invalid,
  onBlur,
}) => {
  const handleTextChange = useCallback(
    (e) => {
      const result = {
        ...data,
        text: e.target?.value || "",
      };
      handleLimitedTimeOfferChange(result);
      if (isInPanel) {
        setModifications(true);
      }
    },
    [data],
  );

  const handleExpirationTypeChange = useCallback(
    (_expirationType) => {
      const result = {
        ...data,
        expirationType: _expirationType,
        expirationDelayInMinutes: undefined,
        expirationDate: undefined,
      };
      handleLimitedTimeOfferChange(result);
      if (isInPanel) {
        setModifications(true);
      }
    },
    [data],
  );

  const handleExpirationDateChange = useCallback(
    (_expirationDate) => {
      const result = {
        ...data,
        expirationDelayInMinutes: undefined,
        expirationDate: _expirationDate?.toISOString(),
      };
      handleLimitedTimeOfferChange(result);
      if (isInPanel) {
        setModifications(true);
      }
    },
    [data],
  );

  const handleExpirationDelayChange = useCallback(
    (_expirationDelayInMinutes) => {
      const result = {
        ...data,
        expirationDelayInMinutes: _expirationDelayInMinutes,
        expirationDate: undefined,
      };
      handleLimitedTimeOfferChange(result);
      if (isInPanel) {
        setModifications(true);
      }
    },
    [data],
  );

  return (
    <>
      {isEditing && (
        <Fieldset className="mb-2">
          <Field>
            <Legend>Limited-Time offer</Legend>
            <InputGroup>
              <Input
                className="focus:ring-0"
                placeholder="Text"
                value={data?.text ?? ""}
                onChange={handleTextChange}
                maxLength={16}
                showCharacterCount
                invalid={errorsMap?.has("text") || invalid}
                autoComplete="off"
                onBlur={(e) => onBlur(e)}
              />
              {error && <ErrorMessage>{error}</ErrorMessage>}
            </InputGroup>
          </Field>
        </Fieldset>
      )}
      {isInPanel && (
        <>
          <Fieldset>
            <Field>
              <RadioGroup
                name="limitedTimeOfferExpirationType"
                value={data.expirationType}
                onChange={handleExpirationTypeChange}
              >
                <RadioField>
                  <Radio value={LimitedTimeOfferExpirationTypeEnum.DELAY} />
                  <Label>Delay</Label>
                  <Description>
                    The offer expires after the given duration
                  </Description>
                </RadioField>
                <RadioField>
                  <Radio
                    value={LimitedTimeOfferExpirationTypeEnum.DATE_TIME_PICKER}
                  />
                  <Label>Expiration date</Label>
                  <Description>
                    The offer expires after the expiration date
                  </Description>
                </RadioField>
              </RadioGroup>
            </Field>
          </Fieldset>

          {data.expirationType === LimitedTimeOfferExpirationTypeEnum.DELAY && (
            <>
              <DelayPicker
                delay={data.expirationDelayInMinutes || 0}
                delayChanged={handleExpirationDelayChange}
                invalid={errorsMap?.get("expirationDelayInMinutes")}
              ></DelayPicker>
              {/* {errorsMap?.has("expirationDelayInMinutes") && (
            <Field>
            <ErrorMessage>
            {errors?.limitedTimeOffer.expirationDelayInMinutes}
            </ErrorMessage>
            </Field>
            )} */}
            </>
          )}

          {data.expirationType ===
            LimitedTimeOfferExpirationTypeEnum.DATE_TIME_PICKER && (
            <>
              <DateTimePicker
                dateTimeChanged={handleExpirationDateChange}
                dataNode={data}
              ></DateTimePicker>
              {/* {errorsMap?.has("expirationDate") && (
            <Field>
            <ErrorMessage>
            {errors?.limitedTimeOffer.expirationDate}
            </ErrorMessage>
            </Field>
            )} */}
            </>
          )}
        </>
      )}
    </>
  );
};
